// Preloader.js
import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import "./preloader.css"

const Preloader = () => {
  useEffect(() => {
    // Water Animation
    const water = document.querySelector('.water');
    const text = document.querySelector('.welcome-text');
    
    gsap.fromTo(
      water,
      { y: -100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 3,
        ease: 'power2.out',
      }
    );

    gsap.fromTo(
      text,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 2,
        delay: 1,
        ease: 'power2.out',
      }
    );
  }, []);

  return (
    <div className="preloader">
      <div className="water"></div>
      <div className="loader-container">
        <h1 className="welcome-text">Welcome to Avit's Room</h1>
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Preloader;
